import { useDealItemPicker } from '../DealItemPicker';
import { Money } from 'components/Money';
import { React } from 'libs/react';
import { calculatePriceCurrency } from 'helpers/Pricing';
import './DealItemPickerTotal.scss';
/**
 * @component DealItemPickerTotal
 * @since 1.0.0
 * @hidden
 */
export function DealItemPickerTotal(props) {
    const { style } = props;
    const { item, variant, packages, options, deal, quantity } = useDealItemPicker();
    if (item == null) {
        return null;
    }
    let total = item.price ? item.price * (quantity !== null && quantity !== void 0 ? quantity : 1) : 0;
    variant
        ? (total = variant.price ? variant.price * (quantity !== null && quantity !== void 0 ? quantity : 1) : 0)
        : total;
    total += getSelectedOptionsTotal(options);
    total += getSelectedPackagesTotal(packages);
    return (React.createElement("div", { className: "deal-item-picker-tool-bar-item" },
        React.createElement("div", { className: "deal-item-picker-tool-bar-item-label" }, t('Total')),
        React.createElement("div", { className: "deal-item-picker-tool-bar-item-value" },
            React.createElement(Money, { value: calculatePriceCurrency(total, deal === null || deal === void 0 ? void 0 : deal.currency) }))));
}
/**
 * @function getSelectedOptionsTotal
 * @since 1.0.0
 * @hidden
 */
function getSelectedOptionsTotal(items) {
    return items.reduce((tot, val) => {
        var _a;
        return tot +
            (val.proposed ? 0 : val.price ? val.price * ((_a = val.quantity) !== null && _a !== void 0 ? _a : 1) : 0);
    }, 0);
}
/**
 * @function getSelectedPackagesTotal
 * @since 1.0.0
 * @hidden
 */
function getSelectedPackagesTotal(items) {
    return items.reduce((tot, val) => {
        var _a;
        return tot +
            (val.proposed
                ? 0
                : val.package.price
                    ? val.package.price * ((_a = val.quantity) !== null && _a !== void 0 ? _a : 1)
                    : 0);
    }, 0);
}
